import set from 'lodash/set';
import * as actionTypes from '../actionTypes/translationsActionTypes';
import { getMessageForLocale } from '../locales';

export function saveMetaData(payload) {
  return {
    type: actionTypes.SAVE_TRANSLATIONS,
    payload: payload
  };
}

export const fetchTranslationsFromClient = params => {
  return (dispatch, getState) => {
    const { language } = params;
    const messagesData = {};
    const localeMessages = getMessageForLocale(language);
    set(messagesData, `screen_labels.clientMessages`, localeMessages);
    dispatch(saveMetaData(messagesData));
  };
};

export default fetchTranslationsFromClient;
